const PhysicianStore = {
	data: {
		physicians: [
			{
				id: '86687',
				firstName: 'Nicola',
				lastName: 'Aaronson',
				filterStatus: true,
			},
			{
				id: '68611',
				firstName: 'Michael',
				lastName: 'Ayotunde Abayomi',
				filterStatus: true,
			},
			{
				id: '89280',
				firstName: 'Carolyn',
				lastName: 'Hostinsky',
				filterStatus: true,
			},
			{
				id: '89302',
				firstName: 'Linda',
				lastName: 'Park',
				filterStatus: true,
			},
			{
				id: '89203',
				firstName: 'Sara',
				lastName: 'Povey',
				filterStatus: true,
			},
			{
				id: '89284',
				firstName: 'Nargess',
				lastName: 'Shargi',
				filterStatus: true,
			},
			{
				id: '89285',
				firstName: 'Leigh',
				lastName: 'Sheppard',
				filterStatus: true,
			},
			{
				id: '89206',
				firstName: 'Yarra',
				lastName: 'Vostrcil',
				filterStatus: true,
			},
		]
	},
	methods: {
		getPhysician($id) {
			let $index = PhysicianStore.data.physicians.findIndex(
				element => element.id == $id
			);

			return PhysicianStore.data.physicians[$index];
		},
		setStatus($id, $status) {
			let $index = PhysicianStore.data.physicians.findIndex(
				element => element.id == $id
			);

			PhysicianStore.data.physicians[$index].filterStatus = $status;
		}
	}
};

export default PhysicianStore;